import styled from 'styled-components';
import { fontFamilyRaleway, colorRed, colorBlue } from 'styleUtils';
export var Title = /*#__PURE__*/styled.h3.withConfig({
  componentId: "sc-ezcukq-0"
})(["font-family:", ";font-size:16px;line-height:1.5;font-weight:600;margin-bottom:10px;"], fontFamilyRaleway);
export var LinksList = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-ezcukq-1"
})(["list-style:none;margin:0;padding:0;"]);
export var LinksListItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-ezcukq-2"
})(["margin:0;padding:0;&:not(:last-child){margin-bottom:8px;}"]);
export var Link = /*#__PURE__*/styled.a.withConfig({
  componentId: "sc-ezcukq-3"
})(["color:", ";font-size:14px;line-height:18px;transition:color 0.3s;&:hover,&:active{color:", ";}"], colorBlue, colorRed);